export const roles = {
  InvoiceCustomer: 'RechnungsKunde',
  InvoiceCustomerPlus: 'RechnungPlus',
  User: 'User',
  Administrator: 'Administrator',
  WebBrief24: 'WebBrief24',
}
